import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';

function EmptyKeyMetrics() {
  return (
    <Typography
      as="div"
      variant="h4"
      fontWeight="bold"
      className="leading-[1.21em] mr-[4%]"
      color="dark"
    >
      --
    </Typography>
  );
}

export default observer(EmptyKeyMetrics);
